export enum FileType {
	AUDIO,
	VIDEO,
}
